<template>
  <div>
    <TopBar :pagetitle="title" back-url="/textbook/license" />
    <div class="topCard">
      <van-swipe ref="TopSwipe" @change="onTopSwipe">
        <van-swipe-item v-for="(item, index) in cardData" :key="index">
          <img :src="item.image">
        </van-swipe-item>
        <div slot="indicator" class="custom-indicator swipeTop">
          <span v-for="(image, index) in cardData" :key="index" @click="gotoTopSwipe(index)">
            <a v-if="NowTopSwipe == index" class="mainColor"><i class="iconfont iconline" /></a>
            <a v-if="NowTopSwipe != index"><i class="iconfont iconline" /></a>
          </span>
        </div>
      </van-swipe>
      <span class="aboutStr">{{ cardData[NowTopSwipe].name }}<br>
        此塑料潜水证书申请费用为￥{{ cardData[NowTopSwipe].price }}</span>
      <p><van-button plain type="info" size="large" @click="getPhysics">加入购物车[x]</van-button></p>
      <p><van-button type="info" size="large" @click="getPhysics">立即购买[x]</van-button></p>
    </div>
  </div>
</template>
<script>
// import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, MyNotify } from '@/utils/base'
import { Button, Swipe, SwipeItem } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    TopBar
  },
  data() {
    return {
      cardId: undefined,
      title: '塑料潜水证书',
      NowTopSwipe: 0,
      cardData: [
        {
          name: 'Manta卡',
          image: '/img/card/card1.jpg',
          price: 388.00
        },
        {
          name: '鲸鲨卡',
          image: '/img/card/card2.jpg',
          price: 288.00
        },
        {
          name: '鲨鱼卡',
          image: '/img/card/card3.jpg',
          price: 188.00
        },
        {
          name: '卡',
          image: '/img/card/card4.jpg',
          price: 998.00
        }
      ]
    }
  },
  created() {
    initPage()
    var url = getUrlKey('cardId')
    if (url !== null) {
      this.cardId = url
    } else {
      MyNotify('error', '证书不存在', 2000)
      this.$router.replace('/textbook/license')
    }
  },
  methods: {
    onTopSwipe(index) {
      this.NowTopSwipe = index
    },
    gotoTopSwipe(index) {
      this.NowTopSwipe = index
      this.$refs.TopSwipe.swipeTo(index)
    }
  }
}
</script>

<style scoped>
.topCard{
  padding: 3em 1em 1em 1em;
  text-align: center;
}

.topCard img{
  /* border-radius: 1em; */
  width: 100%;
}
</style>
